import { render, staticRenderFns } from "./SOMenuDetailPopup.vue?vue&type=template&id=539df915&scoped=true&"
import script from "./SOMenuDetailPopup.vue?vue&type=script&lang=ts&"
export * from "./SOMenuDetailPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SOMenuDetailPopup.vue?vue&type=style&index=0&id=539df915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539df915",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
